module.exports = "/packs/006-7fd0826999ba204d98bb62e8ef1f0919.jpg";